import React from 'react';
import {Button, NewTabIcon, Tooltip, TooltipHandler} from '@genestack/ui';
import {Link} from 'wouter';
import styles from '../right-panel.module.css';
import {useDocumentSidebarState} from '../../../../../document-workflow/common/right-sidebar/hooks/use-document-sidebar-state';
import {EditRightPanelTab} from '../../../../../../components/layout/page-layout/layout-typings';
import {useUserEditingPermissions} from '../../../../../../hooks/user/use-has-permission';

interface Props {
    declarationUrl: string;
}

export function ViewDeclarationButton(props: Props) {
    const {isSidebarOpen, openSidebar, selectedTab, setSelectedTab} =
        useDocumentSidebarState(false);

    const {fullEditingAccess} = useUserEditingPermissions();

    const onClick = React.useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();

            if (!isSidebarOpen) {
                openSidebar();
            }

            if (selectedTab !== EditRightPanelTab.HIERARCHICAL_TREE) {
                setSelectedTab(EditRightPanelTab.HIERARCHICAL_TREE);
            }
        },
        [isSidebarOpen, openSidebar, selectedTab, setSelectedTab]
    );

    if (!fullEditingAccess) {
        return null;
    }

    return (
        <span onClick={onClick} className={styles.viewDeclarationBtn}>
            <TooltipHandler tooltip={<Tooltip>View declaration</Tooltip>}>
                <Link to={props.declarationUrl} target="_blank">
                    <Button size="tiny" ghost iconStart={<NewTabIcon />} />
                </Link>
            </TooltipHandler>
        </span>
    );
}
